import { useEffect } from "react";

export default function TruspilotHeader() {

    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <>
            {/* // <!-- TrustBox widget - Slider --> */}
            <div className="trustpilot-widget" data-locale="en-GB"
                data-template-id="5406e65db0d04a09e042d5fc" data-businessunit-id="5eec7f68e2c6090001e4f541"
                data-style-height="28px" data-style-width="100%" data-theme="light">
                <a href="https://uk.trustpilot.com/review/www.kcsofas.co.uk" target="_blank" rel="noopener"></a>
            </div>
            {/* // <!-- End TrustBox widget --> */}
        </>
    );
}


export function TruspilotMobile() {

    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <>
            {/* // <!-- TrustBox widget - Slider --> */}
            <div className="trustpilot-widget" data-locale="en-GB" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="5eec7f68e2c6090001e4f541" data-style-height="52px" data-style-width="100%">
                <a href="https://uk.trustpilot.com/review/www.kcsofas.co.uk" target="_blank" rel="noopener">Trustpilot</a>
            </div>
            {/* // <!-- End TrustBox widget --> */}
        </>
    );
}
